/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { NewsletterCTAComponentEditor } from "cms/components/components/newsletter-cta/edit";
import { NewsletterCTAComponentDisplay } from "cms/components/components/newsletter-cta/display";
import { getComponentZoneLayout } from "cms/components/components/component";

const NewsletterCTAComponent = (props) => {

    const zoneProps = {
        ...props,
        displayComponent: <NewsletterCTAComponentDisplay />,
        editComponent: <NewsletterCTAComponentEditor />,
    };
    return getComponentZoneLayout(zoneProps);
};

NewsletterCTAComponent.displayName = "NewsletterCTAComponent";
export { NewsletterCTAComponent };
